"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValuationNextStepsFormDefinition = void 0;
const TriggerFieldFormExtension_1 = require("../../../../Plugin/FormExtension/TriggerFieldFormExtension");
const FormHandlerPluginDefinition_1 = require("../../../../PluginType/FormHandler/FormHandlerPluginDefinition");
const MixedFormHandler_1 = require("../../../../PluginType/FormHandler/MixedFormHandler");
const configs_1 = require("../../../../configs/configs");
class ValuationNextStepsForm extends MixedFormHandler_1.default {
    /**
     * @inheritDoc
     */
    getValidationConfig() {
        return configs_1.configs.validationsForSteps.valuation_next_step;
    }
}
exports.default = ValuationNextStepsForm;
exports.ValuationNextStepsFormDefinition = new FormHandlerPluginDefinition_1.default({
    id: "valuation_next_form",
    class: ValuationNextStepsForm,
    extensions: [TriggerFieldFormExtension_1.TriggerFieldFormExtensionDefinition.getId()]
});
